import { FontSizeType } from '@/components/CustomAvatar/CustomAvatar.types';
import { styled } from '@mui/material';

export const AvatarsWrapper = styled('div')`
  display: flex;
  align-items: center;
`;

export const MoreUsersText = styled('p')<{ fontSize?: FontSizeType }>`
  height: 100%;
  margin-left: ${({ theme }) => theme.spacing(1)};
  font-size: ${({ fontSize, theme }) => theme.spacing(fontSize?.mobile || 4)};

  ${({ theme }) => theme.breakpoints.up('sm')} {
    font-size: ${({ theme, fontSize }) =>
      theme.spacing(fontSize?.desktop || 5)};
  }
`;
